<template>
    <div class="security-wrapper">
        <header-security v-if="isJACareerEntrepreApp" />
        <div class="security">
            <b-container
                :class="[isJACareerEntrepreApp ? 'security-container' : '']"
            >
                <b-row v-if="isIntuitApp" class="d4d-decoration"> </b-row>
                <b-row v-if="isJAApp" class="ja-decoration"> </b-row>
                <b-form
                    @submit.prevent="login()"
                    v-if="!isJAUSCareerEntrepreApp"
                >
                    <b-row class="d4d-login">
                        <b-col cols="12" class="mt-1 title">Log In</b-col>

                        <b-col cols="12" class="mt-3">
                            <b-alert :show="hasError" class="error-message">
                                <div class="error-title">
                                    {{ serviceError }}
                                </div>
                                <span class="error-subtitle">{{
                                    serviceErrorDetail
                                }}</span>
                                <span
                                    v-if="hasErrorEmailNoConfirmed"
                                    class="error-subtitle"
                                >
                                    If you never received a confirmation email
                                    please click the
                                    <a href="#" @click="sendConfirmationEmail()"
                                        >resend confirmation link</a
                                    >
                                </span>
                            </b-alert>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                            <label for="email">Email address</label>
                            <input
                                id="email"
                                type="text"
                                v-model="form.email"
                                value=""
                            />
                            <span v-if="emailError" class="form-error"
                                >This field is required</span
                            >
                            <ul class="error-content">
                                <li
                                    class="error-text"
                                    v-for="error in emailErrors"
                                    :key="error"
                                >
                                    {{ error }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col cols="12 mt-4">
                            <label for="password">Password</label>
                            <input
                                id="password"
                                type="password"
                                v-model="form.password"
                                value=""
                            />
                            <span v-if="passwordError" class="form-error"
                                >This field is required</span
                            >
                        </b-col>
                        <b-col cols="12" class="mt-4">
                            <b-button block variant="primary" type="submit"
                                >Log in</b-button
                            >
                        </b-col>
                        <legal-warning button="Log In" />
                        <b-col cols="12" class="mt-3">
                            <div class="separator"></div>
                        </b-col>
                        <b-col cols="12" class="mt-3 text-center">
                            <router-link :to="{ name: 'ForgotPassword' }">
                                <span class="green-text"
                                    >I forgot my password</span
                                >
                            </router-link>
                        </b-col>
                        <b-col cols="12" class="mt-1 mb-4 text-center">
                            <router-link :to="{ name: 'Register' }">
                                <span class="black-text"> New to D4D? </span>
                                <span class="green-text"
                                    >Create an account</span
                                >
                            </router-link>
                        </b-col>
                    </b-row>
                </b-form>
                <b-form
                    @submit.prevent="login()"
                    v-if="isJAUSCareerEntrepreApp"
                >
                    <b-row class="security-content">
                        <b-col cols="12" class="mt-1 security-title"
                            >Log In</b-col
                        >

                        <b-alert
                            :show="hasError"
                            class="error-message col-12 mt-3"
                        >
                            <div class="error-title">{{ serviceError }}</div>
                            <span class="error-subtitle">{{
                                serviceErrorDetail
                            }}</span>
                        </b-alert>

                        <b-col cols="12" class="mt-4 security-button">
                            <b-button
                                block
                                variant="primary"
                                type="submit"
                                class="security-button__primary"
                                @click="authenticateSSOJAUSA"
                            >
                                Log in with JA account
                            </b-button>
                        </b-col>

                        <b-col cols="12" class="mt-3 security-button">
                            <b-button
                                block
                                variant="outline-primary"
                                type="submit"
                                class="security-button__outline"
                                v-on:keyup.enter.space="routeToGuest"
                                @click="routeToGuest"
                            >
                                Log in as guest
                            </b-button>
                        </b-col>
                        <b-col cols="12" class="mt-4 security-description">
                            <p class="security-description__text text--black">
                                By logging in, you agree to our
                                <a
                                    :href="Constants.TERMS_CONDITIONS_URL"
                                    target="_blank"
                                    ><span
                                        class="security-description__text text--green"
                                        >Terms and Conditions</span
                                    ></a
                                >
                                and have read and acknowledge our
                                <a
                                    :href="Constants.PRIVACY_POLICY_URL"
                                    target="_blank"
                                    ><span
                                        class="security-description__text text--green"
                                        >US Privacy Statement</span
                                    ></a
                                >. <br /><span
                                    class="security-description__text text--bold"
                                    >Updated on January 1, 2020</span
                                >
                            </p>
                        </b-col>
                        <b-col class="security-footer">
                            <span class="security-footer__text"
                                >©Junior Achievement USA</span
                            >
                        </b-col>
                    </b-row>
                </b-form>
                <b-col cols="12" class="mt-3" v-else>
                    <b-alert :show="hasError" class="error-message">
                        <div class="error-title">{{ serviceError }}</div>
                        <span class="error-subtitle">{{
                            serviceErrorDetail
                        }}</span>
                    </b-alert>
                    <b-col v-if="hasError" cols="12" class="mt-4">
                        <b-button
                            block
                            variant="primary"
                            type="button"
                            @click="authenticateSSOJAUSA"
                            >Retry Log in</b-button
                        >
                    </b-col>
                </b-col>
                <legal-message v-if="!isJACareerEntrepreApp" />
            </b-container>
        </div>
    </div>
</template>

<script>
import { AuthService, UserService } from "../Services";
import { Spinner, Project } from "@/core/Utils";
import LegalWarning from "../Components/LegalWarning";
import LegalMessage from "../Components/LegalMessage";
import validateForms from "@/core/Mixins/validate-forms";
import HeaderSecurity from "../Components/HeaderSecurity";
import { Storage, Constants } from "@/core/Utils";

export default {
    name: "Login",
    components: {
        LegalWarning,
        LegalMessage,
        HeaderSecurity,
    },
    mixins: [validateForms],
    data() {
        return {
            form: { email: "", password: "" },
            emailError: false,
            passwordError: false,
            serviceError: null,
            serviceErrorDetail: false,
            hasError: false,
            hasErrorEmailNoConfirmed: false,
            Constants: Constants,
        };
    },
    methods: {
        async login() {
            const email = this.form.email;
            const password = this.form.password;
            this.emailError = email === "";
            this.passwordError = password === "";
            this.hasError = false;
            this.hasErrorEmailNoConfirmed = false;
            this.serviceError = null;
            this.serviceErrorDetail = false;

            try {
                if (email && password && this.isValidform()) {
                    Spinner.start();
                    await AuthService.login(email, password);
                    Spinner.stop();

                    const projects = Storage.getProjects();
                    const user = Storage.getUser();

                    setTimeout(function () {
                        projects.forEach(async (project, index) => {
                            project.userId = user.id;
                            await Project.syncProject(
                                project,
                                index,
                                this.isOffline,
                                false,
                            );
                        });
                    }, 2000);

                    this.offGuestHandler();
                    this.$router.push({ name: "home" });
                }
            } catch (err) {
                Spinner.stop();
                this.hasError = true;
                this.serviceError = "Unexpected error, please try again.";
                if (err) {
                    if (err.message && err.message === "Email_No_Confirmed") {
                        this.serviceError = "Your email address isn't verified";
                        this.serviceErrorDetail = "";
                        this.hasErrorEmailNoConfirmed = true;
                    } else {
                        this.serviceError = "Invalid email or password";
                        this.serviceErrorDetail =
                            "To continue, please retype your email address and password.";
                        this.hasErrorEmailNoConfirmed = false;
                    }
                }
            }
        },
        authenticateSSOJAUSA() {
            Spinner.start();
            AuthService.redirecToAuthorizeURL();
        },
        redirectToSSOErrorIfNeeded(errors) {
            if (
                errors &&
                errors.length &&
                errors[0].description === "beErrorSSOIdp"
            ) {
                AuthService.storeIdTokenHint();
                this.$router.push({ name: "beErrorSSOIdp" });
                return true;
            }
            return false;
        },
        loginSSOJAUSA() {
            Spinner.start();
            this.hasError = false;
            AuthService.loginSSOJAUSA()
                .then((response) => {
                    Spinner.stop();
                    if (response.success) {
                        const projects = Storage.getProjects();
                        const user = Storage.getUser();

                        setTimeout(function () {
                            projects.forEach(async (project, index) => {
                                project.userId = user.id;
                                await Project.syncProject(
                                    project,
                                    index,
                                    this.isOffline,
                                    false,
                                );
                            });
                        }, 2000);

                        this.offGuestHandler();
                        this.$router.push({ name: "home" });
                    } else if (response.errors && response.errors.length) {
                        if (this.redirectToSSOErrorIfNeeded(response.errors))
                            return;
                        const error = response.errors[0];
                        this.hasError = true;
                        this.serviceError = error.code;
                        this.serviceErrorDetail = error.description;
                    }
                })
                .catch((err) => {
                    Spinner.stop();
                    if (err && this.redirectToSSOErrorIfNeeded(err.errors))
                        return;
                    this.hasError = true;
                    this.serviceError = "Unexpected error, please try again.";
                    if (err) {
                        this.serviceError = "Error when trying to do SSO Login";
                        this.serviceErrorDetail =
                            "To continue, please retry the login again.";
                    }
                });
        },
        sendConfirmationEmail() {
            const email = this.form.email;
            this.emailError = email === "";
            this.hasError = false;
            this.hasErrorEmailNoConfirmed = false;
            this.serviceError = null;
            this.serviceErrorDetail = false;

            if (email && this.isValidform()) {
                Spinner.start();
                UserService.sendConfirmationEmail(email)
                    .then((response) => {
                        Spinner.stop();
                        if (response.message === "Parent_Consent_Required") {
                            if (response.parentConsentRequired) {
                                this.$router.push({
                                    name: "ParentConsentRequired",
                                    params: { userId: response.user.id },
                                });
                            } else {
                                this.$router.push({
                                    name: "VerifyParentEmail",
                                });
                            }
                        } else {
                            this.$router.push({ name: "VerifyEmail" });
                        }
                    })
                    .catch((err) => {
                        Spinner.stop();
                        this.hasError = true;
                        this.serviceError =
                            "Unexpected error, please try again.";
                        if (err) {
                            this.serviceErrorDetail =
                                "To continue, please retype your email address and password.";
                            this.hasErrorEmailNoConfirmed = false;
                        }
                    });
            }
        },
        routeToGuest() {
            this.onGuestHandler();
            AuthService.storeUserCredentials({
                highContrast: false,
                fontSize: 100,
                language: "en",
            });
            this.$router.push({ name: "home" });
        },
    },
    mounted() {
        const is_redirect = window.location.hash !== "#/";

        if (this.isJAUSApp && !is_redirect) {
            this.authenticateSSOJAUSA();
        } else if (this.isJAUSCareerEntrepreApp && is_redirect) {
            Spinner.start();
            this.loginSSOJAUSA();
        }
    },
};
</script>
<style scoped lang="stylus">
@import "../Styles/security_styles.styl"

.remember
    font-family arial, sans-serif
    font-size 14px
</style>
